<template>
  <div class="payment__content" v-if="adultCertificationYn">
    <!-- header -->
    <div class="layer__header">
      <div class="lyr-title">{{ $t('User.AdultCertification.msg1') }}</div>
      <div class="ft-point">{{ $t('User.AdultCertification.msg2') }}</div>
      <div class="lyr-txt">{{ $t('User.AdultCertification.msg3') }}</div>
    </div>

    <!-- //header -->
    <div class="info-area">
      <div class="info-box">
        <span class="info-img"><img :src="kakaoSrc" alt="" /></span>
      </div>
      <div class="info-box">
        <span class="info-img"><img :src="passSrc" alt="" /></span>
      </div>
    </div>
    <div class="layer__button">
      <button class="btn btn--half btn--color btn-anim btn-kakao-auth" :disabled="adultCertYn" @mouseup="onAdultCert(1)">
        {{ $t('User.AdultCertification.msg4') }}
      </button>
      <button class="btn btn--half btn--color btn-anim btn-pass-auth" :disabled="adultCertYn" @mouseup="onAdultCert(2)">
        {{ $t('User.AdultCertification.msg5') }}
      </button>
    </div>

    <!-- 성인 인증 진행 팝업 -->
    <AdultCert
      v-if="adultCertYn"
      :adultType="adultType"
      @closeAdultCert="adultCertYn = false"
      @setAdultCertFinish="
        adultCertYn = false;
        adultCertFinishYn = true;
      "
      @errorAdultCert="errorAdultCert"
    />

    <!-- 성인 인증 완료 팝업 -->
    <AdultCertFinish
      v-if="adultCertFinishYn"
      @closeAdultCertFinish="
        adultCertFinishYn = false;
        $emit('setOrder');
      "
    />

    <AlertVue :text="this.text" :message="this.message" v-if="alertYn" @setYes="setYes" />
  </div>
</template>
<script>
import adultCert from '@/components/modal/payment/AdultCert.vue';
import adultCertFinish from '@/components/modal/payment/AdultCertFinish.vue';
import audioHelper from '@/js/common/audioHelper.js';
import alertVue from '@/components/modal/alert/AlertSuccess.vue';

export default {
  name: 'adultCertification',
  methods: {
    errorAdultCert(data) {
      this.text = data.message;
      this.alertYn = true;
    },
    setYes() {
      this.text = '';
      this.alertYn = false;
      this.message = '';
    },
    imageLoad() {
      if (typeof this.$i18n != 'undefined') {
        if (this.$i18n.locale == 'jp') {
          this.kakaoSrc = require('@/assets/images/user/img_kakao.png');
          this.passSrc = require('@/assets/images/user/img_pass.png');
        } else if (this.$i18n.locale == 'ko') {
          this.kakaoSrc = require('@/assets/images/user/img_kakao.png');
          this.passSrc = require('@/assets/images/user/img_pass.png');
        } else if (this.$i18n.locale == 'en') {
          this.kakaoSrc = require('@/assets/images/user/img_kakao.png');
          this.passSrc = require('@/assets/images/user/img_pass.png');
        } else if (this.$i18n.locale == 'cn') {
          this.kakaoSrc = require('@/assets/images/user/img_kakao.png');
          this.passSrc = require('@/assets/images/user/img_pass.png');
        } else if (this.$i18n.locale == 'tw') {
          this.kakaoSrc = require('@/assets/images/user/img_kakao.png');
          this.passSrc = require('@/assets/images/user/img_pass.png');
        }
      } else {
        this.imageLoad();
      }
    },
  },
  props: {
    adultCertificationYn: Boolean,
  },
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      kakaoSrc: '',
      passSrc: '',
      adultCertYn: false,
      adultType: 1,
      adultCertFinishYn: false,
      alertYn: false,
      text: '',
      message: '',
    };
  },
  mounted() {
    this.$logInfo(`Enter Bell Select pages`);
    this.imageLoad();
    this.$changeDarkMode(this.darkModeYn);

    try {
      //this.audio.play(); // 20230406 HSSHIN Audio 재생
      audioHelper.playAudio('00200', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
    } catch (ex) {
      console.error(ex);
    }

    this.$showButtonAnimation();
  },
  unmounted() {
    try {
      //this.audio.pause(); // 20230406 HSSHIN Audio 중지
      audioHelper.stopAudio();
    } catch (ex) {
      console.error(ex);
    }
  },
  created() {},
  beforeCreate() {},
  components: {
    AdultCert: adultCert,
    AdultCertFinish: adultCertFinish,
    AlertVue: alertVue,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped>
.payment__content,
.dark .payment__content {
  width: 100%;
}

.info-area {
  height: auto;
  margin-top: 4.2vh;
}

.info-box,
.dark .info-box {
  width: auto;
}

.info-box + .info-box {
  margin-left: 6vw;
}

.layer__button,
.dark .layer__button {
  width: 100%;
  left: 0;
  justify-content: center;
}

.layer__button button,
.dark .layer__button button {
  width: 37%;
}

.layer__button button + button,
.dark .layer__button button + button {
  margin-left: 2.3vw;
}

.btn-bottom-fix .btn--line + .btn--line,
.dark .btn-bottom-fix .btn--line + .btn--line {
  margin-left: 1.6vw;
}

.btn-bottom-fix .btn--line,
.dark .btn-bottom-fix .btn--line {
  margin-left: 0;
}

.btn-kakao-auth {
  background-color: #ffe812;
  color: #36343e;
}

.btn-pass-auth {
  background-color: #ff3a4a;
  color: #ffffff;
}
</style>
